<template>
  <div class='teaPublish'>
    <div class="teaPublish_top">
      <el-cascader
        :options="experList"
        placeholder="请选择实验"
        :show-all-levels="false"
        :props="experProp"
        clearable
        v-model="experCheckParams.experimentid"
        @change="GetDataList"
      ></el-cascader>
      <el-date-picker
        style="margin-left:20px"
        v-model="selectDate"
        type="datetimerange"
        @change="dateChange"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
    </div>
    <div class="teaPublish_body">
      <el-table
        :data="experCheckTableData"
        stripe
        tooltip-effect="dark"
        style="width: 100%"
        empty-text="请选择实验"
        :default-sort="{prop: 'date', order: 'descending'}"
      >
        <el-table-column
          type="index"
          label="序号"
          width="80"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="createusername"
          label="发布人"
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="checkname"
          label="考核名称"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="experimentname"
          label="实验名称"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="classname"
          label="考核班级"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="startdate"
          label="考核开始时间"
          align="center"
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="enddate"
          label="考核结束时间"
          align="center"
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="createdate"
          label="创建时间"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
      </el-table>
      <div>
        <el-pagination
          style="text-align:center;margin-top:20px;"
          :hide-on-single-page="true"
          :total="total"
          :page-size="experCheckParams.pagesize"
          :current-page.sync='experCheckParams.pageindex'
          @current-change="GetDataList"
          layout="prev, pager, next"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Api from '../../api/index'

export default {
  data () {
    return {
      experList: [],
      experProp: {
        label: 'itemname',
        value: 'itemid',
        children: 'children',
        expandTrigger: 'hover',
        emitPath: false,
      },
      total: 0,
      selectDate: '',
      experCheckParams: {
        experimentid: '',
        startdate: '',
        enddate: '',
        pageindex: 1,
        pagesize: 13
      },
      experCheckTableData: []
    }
  },
  created () {
    this.GetDataList()
    this.GetExperTree()
  },
  methods: {

    //获取实验列表
    async GetExperTree () {
      const res = await Api.sum.GetExperTree()
      this.experList = res.rows
    },
    dateChange (e) {
      this.experCheckParams.startdate = e != null ? e[0] : "";
      this.experCheckParams.enddate = e != null ? e[1] : "";
      this.GetDataList()
    },
    //学习实验操作记录
    async GetDataList () {
      const res = await Api.sum.GetDataList(this.experCheckParams)
      if (res.success != true) return this.$message.info(res.msg)
      this.total = res.total
      console.log(res);
      this.experCheckTableData = res.rows
    },
  }
}
</script>
<style lang='less' scoped>
.teaPublish {
  width: 100%;
  height: 100%;
  background: #fff;
  .teaPublish_top {
    padding: 15px;
  }
}
</style>